import CryptoJS from 'crypto-js'
/**
 * 是否为方法格式
 * @param func: 待判断的方法
 * @return boolean
 */
export const isFunc = func => typeof func === 'function'
/* 判断客户端*/
export const judgeClient = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1   // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)     // 判断是否是 iOS终端
  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'IOS'
  }
  return 'PC'
}
/**
 * md5 加密
 */
export function md5(word) {
  if (!word) return ''
  return CryptoJS.MD5(word).toString().toLowerCase()
}
/**
 * 生成接口签名
 * @param {Object} params - URL参数对象
 * @param {Object} data - 请求体数据对象
 * @param {string} userAgent - User-Agent字符串，默认使用navigator.userAgent
 * @return {string} 生成的signature
 */
export function generateSignature(params = {}, data = {}, userAgent = navigator.userAgent) {
  // 合并所有参数
  const allParams = { ...params, ...data }

  // 按key排序并拼接
  const sortedKeys = Object.keys(allParams).sort()
  const paramString = sortedKeys
    .map(key => `${key}=${allParams[key] || ''}`)
    .join('&')

  // 拼接User-Agent
  const signatureString = paramString + userAgent

  // 使用md5加密
  return md5(signatureString)
}
/**
 * 页面滚动到指定element ID处
 * @param targetId: 页面元素的ID
 * @return null
 */
export function scrollToElementId(targetId) {
  if (window && document) {
    document.getElementById(targetId).scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }
}
/**
 * int 分单位转换为元单位
 * @param fen(int):
 * @return (int)
 */
export const fenToYuan = fen => {
  const num = `${fen  }`
  const intNum = num.slice(0, -2)
  const dotNum = num.slice(-2)
  const lastNum = num.slice(-1)
  if (Number(dotNum) > 0) {
    if (Number(lastNum) === 0) {
      return `${intNum  }.${  dotNum.slice(0, 1)}`
    }
    return `${intNum  }.${  dotNum}`
  }
  return Number(intNum)
}
/**
 * int 分单位转换为整数的元单位（int）
 * @param fen(int):
 * @return (int)
 */
export const fenToYuanInt = fen => {
  const num = `${fen  }`
  const intNum = num.slice(0, -2) // 整数位
  return Number(intNum)
}
/**
 * int 元转分
 * @param yuan(int):
 * @return (int)
 */
export const YuanToFen = yuan => {
  return yuan * 100
}
/**
 * 某个对象是否在数组里,并返回index
 * @param arr(array):
 * @param key(string):
 * @param val:
 * @return index (int)
 */
export const objIndexOf = (arr, key, val) => {
  let index = -1
  arr.forEach((item, ind) => {
    if (item[key] === val) {
      index = ind
    }
  })
  return index
}
/**
 * 从url中获取指定参数
 * @param name string:
 * @return string
 */
export function getUrlParam(name) {
  const reg = new RegExp(`(^|&)${  name  }=([^&]*)(&|$)`)
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
/**
 * 过滤掉Obj中所有值为非（null、0、""、undefined等）的键值对
 * @param obj Object:
 * @return string
 */
export function objFilter(obj) {
  if (!obj) {
    return {}
  }
  const keys = Object.keys(obj)
  const newObj = {}
  keys.forEach(item => {
    if (obj[item]) {
      newObj[item] = obj[item]
    }
  })
  return newObj
}
/**
 * todo @hupo 下面为从 原Util.js 文件中迁移出来的公共方法，未做梳理，需要逐步去除，可用的需要补充注释，未补充的不能作为公共方法使用
 */
import Cookies from 'js-cookie'

export const getLocalUrl = () => window.location.href.split('#')[0]
export function injectPdfJs(callback) {
  if (window.pdfjsLib) {
    callback()
    return
  }
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.onload = function() {
    console.log('callback: ', callback)
    callback()
  }
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js' // 使用正确的CDN链接
  document.body.appendChild(script)
}
export function initTcPlayerJs() {
  return new Promise((resolve, reject) => {
    if (window.TcPlayer) {
      resolve(true)
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = '//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.3.js'
      script.onerror = reject
      script.onload = function() {
        resolve(true)
      }
      document.head.appendChild(script)
      return
    }
  })
}
export function aliPlayerJs(isDefer = false) {
  return new Promise((resolve, reject) => {
    if (window.Aliplayer) {
      resolve(true)
    } else {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://g.alicdn.com/de/prismplayer/2.8.8/skins/default/aliplayer-min.css'
      link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
      const script = document.createElement('script')
      script.type = 'text/javascript'
      isDefer && (script.defer = isDefer)
      !isDefer && (script.async = !isDefer)
      script.src = 'https://g.alicdn.com/de/prismplayer/2.8.8/aliplayer-min.js'
      script.onerror = reject
      script.onload = function() {
        resolve(true)
      }
      document.head.appendChild(script)
      return false
    }
  })
}
export function msFormatTime(milliseconds, sy = ':') {
  // 计算小时、分钟和秒
  const hours = Math.floor(milliseconds / 3600000) // 1小时 = 3600000毫秒
  const minutes = Math.floor((milliseconds % 3600000) / 60000) // 1分钟 = 60000毫秒
  const seconds = Math.floor((milliseconds % 60000) / 1000) // 1秒 = 1000毫秒
  // 格式化输出，确保是两位数字
  return `${pad(hours)}${sy}${pad(minutes)}${sy}${pad(seconds)}`
}

function pad(number) {
  return number < 10 ? `0${  number}` : number
}

export function formatTime(timeNum, symbol = '-', needHour = true) {
  // 时间戳，中间替换符号 是否需要时分秒
  const time = new Date(timeNum)
  const year = time.getFullYear()
  const month = time.getMonth() < 9 ? `0${  time.getMonth() + 1}` : time.getMonth() + 1
  const day = time.getDate() < 10 ? `0${  time.getDate()}` : time.getDate()
  const hour = time.getHours() < 10 ? `0${  time.getHours()}` : time.getHours()
  const min = time.getMinutes() < 10 ? `0${  time.getMinutes()}` : time.getMinutes()
  const second = time.getSeconds() < 10 ? `0${  time.getSeconds()}` : time.getSeconds()
  if (needHour) return `${year}${symbol}${month}${symbol}${day} ${hour}:${min}:${second}`
  return `${year}${symbol}${month}${symbol}${day}`
}
export function formatTimeObj(
  timeNum,
  { symbol = '-', needHour = true, onlyHour = false, onlyMinutes = false } = {}
) {
  // 时间戳，中间替换符号 是否需要时分秒
  const time = new Date(timeNum)
  const year = time.getFullYear()
  const month = time.getMonth() < 9 ? `0${  time.getMonth() + 1}` : time.getMonth() + 1
  const day = time.getDate() < 10 ? `0${  time.getDate()}` : time.getDate()
  const hour = time.getHours() < 10 ? `0${  time.getHours()}` : time.getHours()
  const min = time.getMinutes() < 10 ? `0${  time.getMinutes()}` : time.getMinutes()
  const second = time.getSeconds() < 10 ? `0${  time.getSeconds()}` : time.getSeconds()
  if (onlyHour) return `${hour}:${min}:${second}`
  if (onlyMinutes) return `${min}:${second}`
  if (needHour) return `${year}${symbol}${month}${symbol}${day} ${hour}:${min}:${second}`
  return `${year}${symbol}${month}${symbol}${day}`
}
export function formatHour(timeNum) {
  const time = new Date(timeNum)
  const hour = time.getHours() < 10 ? `0${  time.getHours()}` : time.getHours()
  const min = time.getMinutes() < 10 ? `0${  time.getMinutes()}` : time.getMinutes()
  return `${hour}:${min}`
}
export function localResizeImage(options, call) {
  // 初始化Canvas
  const canvas = document.createElement('canvas')
  const mainCtx = canvas.getContext('2d')

  mainCtx.mozImageSmoothingEnabled = false
  mainCtx.webkitImageSmoothingEnabled = false
  mainCtx.msImageSmoothingEnabled = false
  mainCtx.imageSmoothingEnabled = false
  const img = new Image()
  img.src = options.url
  img.onload = () => {
    const w = img.width
    const h = img.height
    canvas.width = w
    canvas.height = h
    mainCtx.fillStyle = '#fff'
    mainCtx.fillRect(0, 0, w, h)
    mainCtx.drawImage(img, 0, 0, w, h)
    img.setAttribute('crossOrigin', 'anonymous')
    const base64 = canvas.toDataURL('image/png', options.compress || 0.8)
    console.log(
      `原图${(options.url.length / 1024).toFixed(2)}kb`,
      `新图${(base64.length / 1024).toFixed(2)}kb`
    )
    call(dataURItoBlob(base64))
  }
}
function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1])
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], {
    type: mimeString
  })
}
export function createUid() {
  let d = new Date().getTime()
  const uid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16)
  })
  return uid
}
export function getRect(el) {
  if (el instanceof window.SVGElement) {
    const rect = el.getBoundingClientRect()
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    }
  }
  return {
    top: el.offsetTop,
    left: el.offsetLeft,
    width: el.offsetWidth,
    height: el.offsetHeight
  }
}
// ---------------------- 品宣 - 低代码平台跳转到趣宣讲登陆后跳回 --------------
export function onSaveRedirectPath(path) {
  // 保存地址
  path && window.localStorage.setItem('threeRedirectPath', path)
}
export function onGetRedirectPath() {
  // 获得缓存地址(encodeURIComponent转码,decodeURIComponent解码)、解码并跳转
  const path = window.localStorage.getItem('threeRedirectPath') ? decodeURIComponent(window.localStorage.getItem('threeRedirectPath')) : null
  onRemoveRedirectPath()
  return path
}
export function onRemoveRedirectPath() {
  // 获得缓存地址后清除
  window.localStorage.removeItem('threeRedirectPath')
}
// ---------------------------------  end  ---------------------------------
export function setLocalStorage(key, value) {
  if (window.localStorage) {
    window.localStorage.setItem(key, value)
  } else {
    Cookies.set(key, value, { expires: 360, path: '/', domain: document.domain })
  }
}
export function getLocalStorage(key) {
  if (window.localStorage) {
    return window.localStorage.getItem(key)
  }
  return Cookies.get(key)
}
export function removeLocalStorage(key) {
  if (window.localStorage) {
    window.localStorage.removeItem(key)
  } else {
    Cookies.remove(key, { path: '/', domain: document.domain })
  }
}

export function setLocalUserAuthToastStatus() {
  setSessionStorage('user_auth_toast', true)
}
export function getLocalUserAuthToastStatus() {
  return getSessionStorage('user_auth_toast')
}
export function setSessionStorage(key, value) {
  if (sessionStorage) {
    sessionStorage.setItem(key, value)
  }
}
export function getSessionStorage(key) {
  return sessionStorage.getItem(key)
}
export function removeSessionStorage(key) {
  sessionStorage.removeItem(key)
}
export function saveLoadPageStatus() {
  setSessionStorage('_pay_load', true)
}
export function getLoadPageStatus() {
  return getSessionStorage('_pay_load')
}
export function removeLoadPageStatus() {
  return removeSessionStorage('_pay_load')
}
export function saveMeetingTime(meetingId, time) {
  setLocalStorage(`${meetingId}_time`, time)
}
export function getMeetingTime(meetingId) {
  return getLocalStorage(`${meetingId}_time`)
}
export function saveMeetingCurrentTime(meetingId, current = 0, isEndPlay = false) {
  setLocalStorage(`${meetingId}_currenttimeEnd`, !isEndPlay ? current : 0)
  if (!current) return
  setLocalStorage(`${meetingId}_currenttime`, current)
}
export function getMeetingCurrentTime(meetingId = '') {
  return getLocalStorage(`${meetingId}_currenttime`)
}
export function getMeetingCurrentTimeEnd(meetingId = '') {
  return getLocalStorage(`${meetingId}_currenttimeEnd`)
}
export function clearMeetingCurrentTime(meetingId) {
  removeLocalStorage(`${meetingId}_currenttime`)
}
export function clearMeetingTime(key) {
  window.localStorage.removeItem(`${key}_time`)
}
export function saveUserIdentityType(userType) {
  setSessionStorage('userIdentityType', userType)
}
export function getUserIdentityType() {
  return getSessionStorage('userIdentityType') || ''
}
export function clearUserIdentityType() {
  removeLocalStorage('userIdentityType')
}

export function setDefaultAddress(address) {
  setLocalStorage('address', address)
}
export function getDefaultAddress() {
  return getLocalStorage('address')
}
export function removeOrderId() {
  removeLocalStorage('dt_orderId')
}
export function saveOrderId(orderId = '') {
  setLocalStorage('dt_orderId', orderId)
}
export function getOrderId() {
  return getLocalStorage('dt_orderId') || ''
}
export function saveRepresent(representId) {
  return setSessionStorage('representId', representId)
}
export function getRepresent() {
  return getSessionStorage('representId')
}
export function removeRepresent() {
  return removeSessionStorage('representId')
}
export function saveOrganize(orgIds) {
  return setSessionStorage('orgIds', orgIds)
}
export function getOrganize() {
  return getSessionStorage('orgIds')
}
export function removeOrganize() {
  return removeSessionStorage('orgIds')
}
export function saveUserFrom(params) {
  return setSessionStorage('userFrom', params)
}
export function getUserFrom() {
  return getSessionStorage('userFrom')
}
export function removeUserFrom() {
  removeSessionStorage('userFrom')
}

export function saveHasOpenMeeting() {
  setLocalStorage('hasOpenMeeting', true)
}
export function getHasOpenMeeting() {
  return getLocalStorage('hasOpenMeeting')
}
export function saveChargeMobile(mobileArr) {
  // 设置电话记录要先获取，合并 然后传入
  return setLocalStorage('chargeMobile', mobileArr.toString()) // localstorag只支持字符串
}
export function getChargeMobile() {
  if (getLocalStorage('chargeMobile')) {
    return getLocalStorage('chargeMobile').split(',') // 转为数组
  }
  return []
}
export function saveRedToastMaxStatus(status) {
  setLocalStorage('redToastMax', status)
}
export function getRedToastMaxStatus() {
  return getLocalStorage('redToastMax')
}
export function removeChargeMobile() {
  return removeLocalStorage('chargeMobile')
}
export function saveRedPacket() {
  // 新用户红包强提醒 只显示一次
  return setLocalStorage('redPacket', true)
}
export function getRedPacket() {
  return getLocalStorage('redPacket')
}
// 判断当前医生是否有患者管理权限
export function hasPatient() {
  return getSessionStorage('dotor_authority')
}
// 存储当前医生患者管理权限
export function savePatient(status) {
  // 患者权限状态 yes no fail
  setSessionStorage('dotor_authority', status)
}
export function setProductHistory(arr) {
  setLocalStorage('product', arr)
}
export function getProductHistory() {
  return getLocalStorage('product')
}
export function removeProductHistory() {
  removeLocalStorage('product')
}
export function saveLocalUserName(tel = '') {
  return setLocalStorage('userMobile', tel)
}
export function getLocalUserName() {
  return getLocalStorage('userMobile') || ''
}
export function setProductIds(arr) {
  setSessionStorage('productIds', arr)
}
export function getProductIds() {
  return getSessionStorage('productIds')
}
export function getPath() {
  return getSessionStorage('redirect_path') || ''
}
export function removePath() {
  return removeSessionStorage('redirect_path')
}
export function savePath(path) {
  return setSessionStorage('redirect_path', path)
}
export function getBeforeFacePath() {
  return getLocalStorage('beforeFacePath') || ''
}
export function removeBeforeFacePath() {
  return removeLocalStorage('beforeFacePath')
}
export function saveBeforeFacePath(path) {
  return setLocalStorage('beforeFacePath', path)
}

// 删除url中参数
export async function delUrlParam(param) {
  const obj = new window.URL(window.location.href)
  obj.searchParams.delete(param)
  history.replaceState(null, '', obj.href)

  return obj.href
}

export function urlObject(url) {		// 将url？后的参数转换为对象
  const obj = {}
  if (/\?/.test(url)) {
    const urlString = url.substring(url.indexOf('?') + 1)
    const urlArray = urlString.split('&')
    for (let i = 0, len = urlArray.length; i < len; i++) {
      const urlItem = urlArray[i]
      const item = urlItem.split('=')
      obj[item[0]] = item[1]
    }
    return obj
  }
  return null
}
export function getHash(name) {
  const reg = new RegExp(`(^|&)${  name  }=([^&]*)(&|$)`, 'i')
  const r = window.location.hash && window.location.hash.split('#')[1].match(reg) || ''
  const str = r ? unescape(r[2]) : ''
  return str
}
export function additionNum() {
  let num = 0
  if (arguments.length) {
    for (const item of [...arguments]) {
      num += Number(item || 0)
    }
  }
  return num
}

// 深拷贝
export function deepClone(target) {
  // 定义一个变量
  let result
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = [] // 将result赋值为一个数组，并且执行遍历
      for (const i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]))
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {}
      for (const i in target) {
        result[i] = deepClone(target[i])
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target
  }
  // 返回最终结果
  return result
}

/**
 *  校/获取数据类型
 *  @param {*} data: 数据
 *  @param {*} type: 类型
 * */

export function getDataType(data, type) {
  const dataType = Object.prototype.toString.call(data).slice(8, -1).toLowerCase()
  if (type) {
    return dataType === type
  }
  return dataType
}

// 修改对象里的某个属性值
export function updateObjVal(obj, keys, val) {
  const keyList = keys.split('.')
  let tempObj = obj
  keyList.slice(0, keyList.length - 1).forEach(key => {
    if (!tempObj[key]) {
      tempObj[key] = {}
    }
    tempObj = tempObj[key]
  })
  tempObj[keyList[keyList.length - 1]] = val
  return obj
}

// 一次性调用
export function once(fn) {
  let called = false

  return function() {
    if (!called) {
      called = true
      fn.apply(this, arguments)
    }
  }
}

/**
 * 检查是否在微信开发者工具环境中
 * @returns {boolean} 是否为微信开发者工具
 */
export function isWeChatDevTools() {
  // 检查是否存在微信开发者工具独有的全局变量
  // eslint-disable-next-line no-undef
  if (typeof wx !== 'undefined' && typeof wx.getSystemInfo !== 'undefined') {
    return true
  }

  // 检查是否存在微信开发者工具独有的环境信息
  if (typeof __wxConfig !== 'undefined') {
    return true
  }

  // 检查是否存在微信开发者工具独有的userAgent信息
  if (navigator && navigator.userAgent && /wechatdevtools/i.test(navigator.userAgent)) {
    return true
  }

  // 检查是否存在微信开发者工具独有的window属性
  if (window.__wxjs_environment === 'miniprogram') {
    return true
  }

  return false
}

export function loadScript(src, { onload, onerror }) {
  const script = document.createElement('script')
  script.src = src
  script.onload = onload
  script.onerror = onerror
  document.head.appendChild(script)
}
// checkUser 公共方法
export function handleUserError(errorCode, router) {
  if ([10026, 10036].includes(errorCode)) {
    // 登录限制用户，只能跳转到用户安全中心
    router.replace({
      name: 'UserSupportCenter'
    })
    return
  }
  if (errorCode === 1001) {
    window.localStorage.removeItem('token')
    window.location.reload()
  }
}

export function getPlatformLaborStr(isEnabled = false, platformType) {
  if (isEnabled) {
    switch (platformType) {
      case 3:
      case 5:
      case 6:
        return '灵工平台'
      case 4:
        return '普通劳务'
      case 7:
        return '平台劳务'
      default:
        return ''
    }
  } else {
    switch (platformType) {
      case 3:
      case 5:
      case 6:
        return '灵工平台'
      case 4:
        return '平台劳务'
      default:
        return ''
    }
  }
}
